import React from "react";
import PT from "prop-types";
import styled from "styled-components";
import Fieldset from "_c/form/Fieldset";
import { ToggleButtonGroup, ToggleButton } from "_c/ToggleButton";

const Wrap = styled(Fieldset)`
  margin-bottom: 0;
  border: none;
`;

const PhoneEmailToggler = (props) => {
  return (
    <Wrap className={props.className}>
      <ToggleButtonGroup value={props.value} onChange={props.onChange}>
        <ToggleButton value="phone">{props.t("common:phone")}</ToggleButton>
        <ToggleButton value="email">Email</ToggleButton>
      </ToggleButtonGroup>
    </Wrap>
  );
};
PhoneEmailToggler.propTypes = {
  value: PT.oneOf(["email", "phone"]).isRequired,
  className: PT.string,

  t: PT.func.isRequired,
  onChange: PT.func.isRequired,
};

export default PhoneEmailToggler;
